import React from "react";
import { SketchPicker } from "react-color";

function ColorButtonPicker(props) {
  const { handleChange, togglePicker, showPicker, colorHex } = props;
  return (
    <>
      <div
        style={{
          padding: "5px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
        }}
        onClick={() => togglePicker()}
      >
        <div
          className="color-rec-container"
          style={{
            marginTop: 0,
            background: `${colorHex}`,
          }}
        />
      </div>
      {showPicker ? (
        <div
          style={{
            position: "fixed",
            zIndex: "2",
          }}
        >
          <div
            style={{
              position: "fixed",
              top: "0px",
              right: "0px",
              bottom: "0px",
              left: "0px",
            }}
            onClick={togglePicker}
          />
          <SketchPicker
            color={colorHex}
            onChange={(color) => handleChange(color)}
          />
        </div>
      ) : null}
    </>
  );
}

export { ColorButtonPicker };
